<template>
  <StyleProvider hash-priority="high" :transformers="transformers">
    <ConfigProvider :locale="getAntdLocale" :theme="theme" :getPopupContainer="getBaseContainer">
      <RouterView />
      <AppDevPanel />
      <GlobalModal />
      <ExportTaskModal />
      <AsyncTaskModal />
      <AsyncExportModal />
      <SendMessageModal />
      <FloatMenu v-if="getUserStore().getToken" />
    </ConfigProvider>
  </StyleProvider>
</template>

<script lang="ts" setup>
  import 'dayjs/locale/zh-cn';
  import { ConfigProvider, notification, StyleProvider } from 'ant-design-vue';
  import { $MTS, getBaseContainer, useConfirm } from '@mts-fe/utils';
  import { AppDevPanel } from '@mts/components/Application';
  import { AsyncTaskModal, ExportTaskModal } from '@mts/components/Base';
  import { FloatMenu } from '@mts/components/CacheMenu';
  import { AsyncExportModal } from '@mts/components/Export';
  import { t } from '@mts/hooks/web/useI18n';
  import { useTitle } from '@mts/hooks/web/useTitle';
  import { useLocale } from '@mts/locales/useLocale';
  import { theme, transformers } from '@mts/adapter';
  import SendMessageModal from '@/components/SendMessage/Modal.vue';
  import GlobalModal from '@/views/common/global/index.vue';
  import { getUserStore } from './store';

  notification.config({
    top: 50,
    maxCount: 10,
    duration: 10 * 1000,
  });

  // support Multi-language
  const { getAntdLocale } = useLocale();

  // Listening to page changes and dynamically changing site titles
  useTitle();

  let upgradeModal;
  const showUpgradeModal = () => {
    upgradeModal = useConfirm({
      title: t('g.25110002'),
      content: t('g.25110003'),
      okText: t('g.25110001'),
      cancelText: t('g.26060004'),
      onOk: () => $MTS.App.restart(),
      onCancel: () => {
        setTimeout(showUpgradeModal, 5 * 60 * 1e3);
      },
    });
  };
  document.body.addEventListener('plugin_web_update_notice', (e) => {
    console.log('plugin_web_update_notice :>> ', e);
    if (upgradeModal || $MTS.App.prop($MTS.PROP_LOCAL_RUN) === '1') return;
    showUpgradeModal();
  });
</script>
